import React, { Component } from 'react';
// import styled from 'styled-components'
import classes from './App.css';
import Person from './Person/Person'
import ErrorBoundary from './ErrorBoundary/ErrorBoundary'

class App extends Component {
    state = {
        persons: [
            { id: '567i8o', iam: 'Андрей', iamnot: 'Андроид' },
            { id: '43retfgv', iam: 'Vitja', iamnot: 'Stiralnaja machina' },
            { id: 'f34f3f', iam: 'Olga', iamnot: 'Posudamojetsnaja machina' },
            { id: 'f234tfrd', iam: 'Anja', iamnot: 'Gril' }
        ],
        otherState: 'RANDOM VÄRK',
        showPersons: false
    }

    switchAndreiHandler = (newAndrei) => {
        // console.log('KURWA');
        // DON'T DO THIS! this.state.persons[0].name = 'KURWA'
        this.setState({
            persons: [
                { iam: newAndrei, iamnot: 'Андроид' },
                { iam: 'Vitja', iamnot: 'Stiralnaja machina' },
                { iam: 'Olga', iamnot: 'Posudamojetsnaja machina' },
                { iam: 'Anja', iamnot: 'Kuritsõ Gril' }
            ]
        })
    }

    nameChangedHandler = (event, id) => {
        const personIndex = this.state.persons.findIndex(p => {
            return p.id === id
        })

        const person = {
            ...this.state.persons[personIndex]
        }

        person.iam = event.target.value

        const persons = [...this.state.persons]
        persons[personIndex] = person

        this.setState({ persons: persons })
    }

    togglePersonsHandler = () => {
        const doesShow = this.state.showPersons
        this.setState({ showPersons: !doesShow })
    }

    deletePersonsHandler = (personIndex) => {
        const persons = [...this.state.persons]
        persons.splice(personIndex, 1)
        this.setState({ persons: persons })
    }

    render() {

        let persons = null
        let btnClass = ''

        if (this.state.showPersons) {
            persons = (
                <div>
                    {this.state.persons.map((person, index) => {
                        return <ErrorBoundary key={person.id}> 
                            <Person
                                click={() => this.deletePersonsHandler(index)}
                                iam={person.iam}
                                iamnot={person.iamnot}
                                changed={(event) => this.nameChangedHandler(event, person.id)} />
                        </ErrorBoundary>
                    })}
                </div>
            )

            btnClass = classes.Red
        }

        const assignedClass = []

        if (this.state.persons.length <= 2) {
            assignedClass.push(classes.red)
        }
        if (this.state.persons.length <= 1) {
            assignedClass.push(classes.bold)
        }

        return (
            <div className={classes.App}>
                <h1>I am a LAMBDA Reactor app</h1>
                <p className={assignedClass.join(' ')}>Who knows?</p>
                <button className={btnClass} onClick={this.togglePersonsHandler}>
                    Switch Андрей
                </button>
                {persons}
            </div>
        );
        // return React.createElement('div', {className: 'App'}, React.createElement('h1', null, 'I am a \'LAMBDA\' Reactor app'))
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js